import { type FC, type MutableRefObject } from 'react';
import cn from 'classnames';
import { type Swiper as SwiperInstance } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { convertRemToPixels } from '@/common/lib/convertRemtoPx';

import { ContractStepTerms } from '../../ContractStepTerms/ContractStepTerms';
import { FailOverlay } from '../../FailOverlay/FailOverlay';

import { useBlitzContractTerms } from './blitz-contract-terms.hook';

interface BlitzContractTermsProps {
  swiperRef: MutableRefObject<SwiperInstance | null>;
  kind: 'Blitz' | 'BlitzPlus';
  isContractExpired: boolean;
}

const BlitzContractTerms: FC<BlitzContractTermsProps> = ({
  swiperRef,
  kind,
  isContractExpired,
}) => {
  const { list, activeStep, isFail } = useBlitzContractTerms(kind);

  return (
    activeStep !== undefined && (
      <div className="w-full relative">
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          initialSlide={activeStep - 1}
          spaceBetween={24}
          loop={false}
          draggable={false}
          allowTouchMove={false}
          centeredSlides={true}
          className="w-full h-[206px] mt-[10px] relative"
          slidesPerView={'auto'}
        >
          {list.map((props) => {
            const isActiveStep = props.step === activeStep;

            return (
              <SwiperSlide
                key={`step ${props.step}`}
                style={{
                  width: convertRemToPixels(isActiveStep ? 11.5 : 8),
                  opacity:
                    !isActiveStep || isFail || isContractExpired ? 0.5 : 1,
                }}
              >
                <ContractStepTerms
                  {...props}
                  isContractExpired={!!isContractExpired}
                  plug={
                    props.step > activeStep
                      ? {
                          cardsCount: 4,
                        }
                      : undefined
                  }
                  classNames={{
                    wrapper: cn('w-full h-full justify-center'),
                    list: 'grid w-full aspect-square grid-rows-2 grid-cols-2 gap-2',
                  }}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
        <FailOverlay kind={kind} />
      </div>
    )
  );
};

export { BlitzContractTerms };
